'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BASE_URI = undefined;
exports.normalizeUpdates = normalizeUpdates;
exports.normalizeRetries = normalizeRetries;
exports.normalizeResponse = normalizeResponse;
exports.toParams = toParams;
exports.fetchAvatars = fetchAvatars;

var _underscore = require('../utils/underscore');

var _AvatarResponseTypes = require('../constants/AvatarResponseTypes');

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _immutable = require('immutable');

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BASE_URI = exports.BASE_URI = _enviro2.default.getShort() === 'qa' ? 'https://api.hubapiqa.com/socialintel/v1/avatars/data' : 'https://api.hubapi.com/socialintel/v1/avatars/data';

/**
 * Reduces the original keys and the response into a Map of lookup => url.
 *
 * We need the original keys because reponses of different types return
 * inconsistent values for `lookup` and `originalLookup`.
 *
 * For example, a `DOMAIN` response will define `lookup` but a `QUEUED` response
 * does not.
 *
 * @param  {Array<string>}
 * @param  {Array<Object>}
 * @return {Map<string,?string>}
 */
function normalizeUpdates(keys, response) {
  return response.reduce(function (updates, _ref, index) {
    var lookup = _ref.lookup,
        url = _ref.url;

    var originalLookup = keys[index];
    var updatedResult = updates.set(originalLookup, url);
    if (lookup && lookup !== originalLookup) {
      return updatedResult.set(lookup, url);
    }
    return updatedResult;
  }, (0, _immutable.Map)());
}

/**
 * Reduces the original keys and the response into a Set of keys that are QUEUED
 * and should be retried.
 *
 * We need the original keys because QUEUED responses don't include the lookup.
 *
 * @param  {Array<string>}
 * @param  {Array<Object>}
 * @return {Set<string>}
 */
function normalizeRetries(keys, response) {
  return response.reduce(function (keysToRetry, _ref2, index) {
    var responseType = _ref2.responseType;

    if (responseType !== _AvatarResponseTypes.QUEUED) {
      return keysToRetry;
    }
    return keysToRetry.add(keys[index]);
  }, (0, _immutable.Set)());
}

/**
 * @param  {Array<string>}
 * @param  {Array<Object>}
 * @return {{retry: Set<string>, updates: Map<string,?string>}}
 */
function normalizeResponse(keys, response) {
  return {
    retry: normalizeRetries(keys, response),
    updates: normalizeUpdates(keys, response)
  };
}

/**
 * Takes a list of keys in transforms them to a JSON structure that the api
 * understands.
 *
 * @param  {Array<string>}
 * @return {Array<{emails: ?Array<string>, domain: ?string}>}
 */
function toParams(keys) {
  (0, _invariant2.default)(Array.isArray(keys), 'expected `keys` to be an array but got `%s`', keys);
  return keys.map(function (item) {
    if (item.indexOf('@') > -1) {
      return { emails: [item] };
    }
    return { domain: item };
  });
}

/**
 * Uses `fetcher` to retrieve and then normalize responses from the API.
 *
 * @param  {(uri: string, data: Array<Object>) => Promise<Object>}
 * @param  {number}
 * @return {Set<string>}
 */
function fetchAvatars(fetcher, portalId, keys) {
  (0, _invariant2.default)(typeof portalId === 'number', 'expected `portalId` to be a number but got `%s`', portalId);
  (0, _invariant2.default)(_immutable.Set.isSet(keys), 'expected `keys` to be a Set but got `%s`', keys);
  (0, _invariant2.default)(typeof fetcher === 'function', 'expected `fetcher` to be a function but got `%s`', fetcher);
  var keysArray = keys.toArray();
  return fetcher(BASE_URI + '?portalId=' + portalId, toParams(keysArray)).then((0, _underscore.partial)(normalizeResponse, keysArray));
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/avatar/AvatarAPI.js
// module id = 223
// module chunks = 0 1